import { productsAds, shopify } from '../../ads'

module.exports = () => {
  shopify({
    containerId: 'shopify-embed',
  })
  productsAds()
}
